import { authGetAll } from '../../http';

export const getCurrentSerenisCouponCode = async () => {
  return await authGetAll('api/v1/integrations/serenis/coupon/current');
};

export const requestSerenisCouponCode = async () => {
  return await authGetAll('api/v1/integrations/serenis/coupon');
};
